module.exports = __webpack_public_path__ + "img/laason_act.0dc06f86.png";